import '@arcgis/core/assets/esri/themes/light/main.css';
import '@esri/calcite-components/main.css';
import './App.css';

import { ApplicationWrapper } from '@innovyze/stylovyze';
import React from 'react';
import { miniPageRoutes } from './pages';
import { globalization } from './i18n/globalization';

function App() {
	return (
		<ApplicationWrapper
			pages={miniPageRoutes}
			globalization={globalization}
		/>
	);
}

export default App;
